import AssetLoanApprovalTable from "./ApprovalTable";

const FieldOfficerAssetLoanApproval = () => <AssetLoanApprovalTable level="fieldOfficer" />;

export default FieldOfficerAssetLoanApproval;
